/* global axios */
// As ações de drip (start/pause/resume/preview/recipients) PRECISAM do axios
// GLOBAL (window.axios = createAxios(axios)), que carrega os headers de auth
// (DeviseTokenAuth). Importar 'axios' cru aqui criava requisições SEM auth -> 401
// -> o front mostrava o genérico "Não foi possível iniciar o disparo" (no corpo do
// 401 vem {errors:[...]} plural, não {error}). ApiClient usa o mesmo global.
import ApiClient from './ApiClient';
import { browserTimezone } from 'dashboard/helper/browserTimezone';

// A janela 10-21 do drip é interpretada neste fuso; sem ele, vale o da inbox
// (default de fábrica: UTC), que fez campanhas dispararem às 07h BRT
// (incidente 2026-08-16). Injetado aqui, e não no form, para valer para
// qualquer caminho que crie ou edite um drip.
const withDripTimezone = data => {
  if (!data || !data.drip_config || data.drip_config.timezone) return data;
  return {
    ...data,
    drip_config: { ...data.drip_config, timezone: browserTimezone() },
  };
};

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  create(data) {
    return super.create(withDripTimezone(data));
  }

  update(id, data) {
    return super.update(id, withDripTimezone(data));
  }

  // Disparo em massa v2 (drip): controles e leitura por campanha.
  start(id) {
    return axios.post(`${this.url}/${id}/start`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  preview(id) {
    return axios.get(`${this.url}/${id}/preview`);
  }

  recipients(id) {
    return axios.get(`${this.url}/${id}/recipients`);
  }

  // Prévia do público ANTES de a campanha existir: quantos recebem e quantos
  // ficam de fora, por motivo. Só leitura, nada é gravado no servidor.
  audiencePreview(campaign) {
    return axios.post(`${this.url}/audience_preview`, { campaign });
  }
}

export default new CampaignsAPI();
